import { BaseSerializer } from "./baseSerializer.ts";
import { Person } from "../person.model.ts";
import { MediaFileSerializer } from "./mediaFileSerializer.ts";

export class PersonSerializer extends BaseSerializer {
  public deserialize(data: Record<string, any>): Person {
    const person = new Person();

    this._copyAttributes(person, data);

    if (data.profile_picture) {
      const mediaSerializer = new MediaFileSerializer();
      person.profile_picture = mediaSerializer.deserialize(
        data.profile_picture
      );
    }

    return person;
  }
}
